import { render, staticRenderFns } from "./ShowResultsPage.vue?vue&type=template&id=451cd082"
import script from "./ShowResultsPage.vue?vue&type=script&lang=ts"
export * from "./ShowResultsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports